import React from 'react'
import { Chip, Typography } from '@mui/material'
import { lighten, useTheme } from '@mui/material/styles'
import { graphql, useFragment } from 'react-relay/hooks'
import { Specialization_Specialization$key } from '__generated__/Specialization_Specialization.graphql'

export interface ISpecializationProps {
  specialization: Specialization_Specialization$key
}

function Specialization(props: ISpecializationProps) {
  const { specialization: specializationFragmentRef } = props
  const theme = useTheme()

  const specialization = useFragment(graphql`
    fragment Specialization_Specialization on Specialization {
      id
      name
    }
  `, specializationFragmentRef)

  if (specialization?.name) {
    return (
      <Chip
        style={{ margin: theme.spacing(0, 1, 1, 0), background: lighten(theme.palette.secondary.main, 0.17) }}
        label={(
          <Typography variant="body2" style={{ color: '#FFF' }}>
            {specialization.name}
          </Typography>
        )}
      />
    )
  }

  return null
}

export default React.memo(Specialization)
